import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations directly as JavaScript modules
import enCommon from '../locales/en.js';
import frCommon from '../locales/fr.js';
import swCommon from '../locales/sw.js';

// Add debugging logs
console.log('🔧 [i18n] Initializing i18n system...');
console.log('🔧 [i18n] Loaded translations:', { en: Object.keys(enCommon), fr: Object.keys(frCommon), sw: Object.keys(swCommon) });

// Read persisted language from localStorage before initializing i18n
const persistedLang = localStorage.getItem('dashbasket_language');

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: persistedLang || 'en', // use persisted language if available
    fallbackLng: 'en',
    debug: true, // Enable debug mode always

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'dashbasket_language',
      caches: ['localStorage'],
    },

    ns: ['common'],
    defaultNS: 'common',

    supportedLngs: ['en', 'fr', 'sw'],

    resources: {
      en: {
        common: enCommon
      },
      fr: {
        common: frCommon
      },
      sw: {
        common: swCommon
      }
    },
  });

// Add event listeners for debugging
i18n.on('initialized', (options) => {
  console.log('🎉 [i18n] Initialized with options:', options);
});

i18n.on('loaded', (loaded) => {
  console.log('📚 [i18n] Resources loaded:', loaded);
});

i18n.on('languageChanged', (lng) => {
  console.log('🔄 [i18n] Language changed to:', lng);
  console.log('🗂️ [i18n] Available resources:', i18n.getResourceBundle(lng, 'common'));
  console.log('🔍 [i18n] Sample keys:', Object.keys(i18n.getResourceBundle(lng, 'common') || {}).slice(0, 5));
});

i18n.on('missingKey', (lng, namespace, key, res) => {
  console.error(`🚫 [i18n] Missing key: ${lng}.${namespace}.${key} -> ${res}`);
});

i18n.on('failedLoading', (lng, ns, msg) => {
  console.error(`💥 [i18n] Failed loading: ${lng}.${ns} - ${msg}`);
});

export default i18n; 